import { state } from "@src/state";
export function setScreenFullscreen(isOpen) {
    state.meeting.studio.screen.setPanelFullscreen(isOpen);
}
